

























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { qcList, qcOperation, qcOperationAll } from '@/api/task/crowd';
import { detail as taskDetail } from '@/api/task/common';
import { detail as judgeDetail } from '@/api/task/judge';
import { qcCheat } from '@/api/task/crowd';
import {DOMAIN, HTTPDOMAIN,mobileProject,JIDU_DOMAIN} from '@/global/constants';
import inspectExpand from '@/components/inspectExpand.vue';

@Component({
  components: {
    inspectExpand,
  },
})
export default class Inpect extends Vue {
  private dataList: object[] = [];
  private total: number | string = 0;
  private inspectSelection = [];
  private task: object = {};
  private showId: string = '0';
  private rejectVisible = false;
  private noPassReason = '';
  private reasonError = false;
  private operationType ='';

  private selectOperation = {
    QC_OPERATION_PASS: '7',
    QC_OPERATION_REJECT: '8',
    QC_OPERATION_REDO: '9',
  };
  // 搜索 入参
  private searchParams: object = {
    mlid: '',
    puid: '',
    pteamid: '',
    pkg_id:'',
  };
  // 默认 入参
  private listParams: object = {
    page: 1,
    pageSize: 20,
  };

  private columnsSchema: object[] = [
    {
      type: 'expand',
      width: 50,
      render: (h, params) => {
        return h(inspectExpand, {
          props: {
            row: params.row,
          },
        });
      },
    },
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    {
      title: '序号',
      key: 'index',
      align: 'center',
    },
    {
      title: '题目ID',
      key: 'id',
      align: 'center',
    },
    {
      title: '数据ID',
      key: 'lid',
      align: 'center',
    },
    {
      title: '题包ID',
      key: 'pkg_id',
      align: 'center',
    },
    {
      title: '审核ID',
      slot: 'puid',
      align: 'center',
    },
    {
      title: '团队ID',
      key: 'pteamid',
      align: 'center',
    },
    {
      title: '提交时间',
      key: 'time',
      align: 'center',
      slot: 'time',
    },
    {
      title: '结果数据',
      key: 'answer',
      align: 'center',
      slot: 'operate',
    },
  ];
  @Watch('$route')
  private routechange(to: any, from: any) {
    if (to.name == 'inspectDetail') {
      this.getList({});
      this.getTask(); // 重新加载数据
    }
  }
  private created() {
    this.getList({});
    this.getTask();
  }
  private async getList(params) {
    // 质检列表 入参
    if(!this.$route.params.puid){
      this.$Message.success("审核人不能为空");
    }
    const new_params = Object.assign(
      {
        mid: this.$route.params.id,
        puid:this.$route.params.puid,
        pkg_id: this.$route.query.pkg_id
      },
      this.listParams,
      params
    );

    const data = (await qcList(new_params)) as any;
    // 序号根据分页递增
    data.rows.forEach((item, idx) => {
      item.index =
        idx +
        1 +
        ((new_params as any).page - 1) * (new_params as any).pageSize;
      return item;
    });
    this.$nextTick(() => {
      this.dataList = data ? data.rows : [];
      this.total = data ? data.total : 0;
    });

  }
  private async getTask() {
    this.task = this.$store.state.task;
    if (!(this.task && (this.task as any).id)) {
      const page = this.$route.params.page;
      const params = { id: this.$route.params.id };
      let resp: any;
      if (page == 'judge') {
        resp = await judgeDetail(params);
      } else {
        resp = await taskDetail(params);
      }
      this.$nextTick(() => {
        this.task = resp.result;
        this.$store.commit('setTask', resp.result);
      });
    }
  }
  public selectChange(selection) {
    // this.inspectSelection = selection.map(item => item.id);
    this.inspectSelection = selection;
    console.log(this.inspectSelection);
  }
  // 搜索
  private handleSearch() {
    let options = {};
    const params = this.searchParams;

    for (let key in params) {
      if (params[key] !== '') {
        options[key] = params[key];
      }
    }
    this.getList(options);
  }
  // 重置
  private handlereset() {
    this.searchParams = {
      mlid: '',
      puid: '',
      pteamid: '',
      pkg_id:'',
    };
    this.getList({});
  }
  // 分页(带条件分页)
  private changePage(data) {
    let options = {};
    const params = this.searchParams;

    for (let key in params) {
      if (params[key] !== '') {
        options[key] = params[key];
      }
    }
    (this.listParams as any).page = data;
    this.getList(options);
  }
  // 切换分页条数
  private changePageSize(data) {
    (this.listParams as any).pageSize = data;
    this.changePage(1);
  }
  // 通过
  private handlePass() {
    this.operationType = '7'
    this.$Modal.confirm({
      title: '通过',
      content: '您确定要通过这些记录吗？',
      onOk: () => {
        this.selectHandle();
      },
    });
  }

  // 不通过
  private showReject(type) {
    this.rejectVisible = true;
    this.operationType = type;
  }
  private cancelReject() {
    this.rejectVisible = false;
  }
  private handleReject() {
    if (this.noPassReason == '') {
      this.reasonError = true;
      return;
    } else {
      this.rejectVisible = false;
      this.selectHandle();
    }
  }

  // 操作数据处理
  private async selectHandle() {
    const select = this.inspectSelection.map(item => item.id);
    let reqData: any = {
      ids: JSON.stringify(select),
      reason: this.noPassReason
    }
    const res: any = await qcOperation(this.operationType,reqData);
    if (res.code === '200') {
      this.$Message.success('操作成功');
    } else {
      this.$Notice.warning({ desc: res.message });
    }
    this.getList({});
  }
  // 全部通过
  private handlePassAll() {
    this.$Modal.confirm({
      title: '全部通过',
      content: '您确定要通过所有记录吗',
      onOk: () => {
        this.selectHandleAll();
      },
      onCancel: () => {},
    });
  }
  // 全部数据处理
  private async selectHandleAll() {
    const res: any = await qcOperationAll({
      operation: this.selectOperation.QC_OPERATION_PASS,
      mid: (this.task as any).id,
    });
    if (res.code === '200') {
      this.$Message.success('操作成功');
    } else {
      this.$Message.success(res.message);
    }
    this.getList({});
  }
  //质检
  private handlecheck(id, mid,puid) {
    this.$nextTick(() => {
      this.showId = id;
    });
    let audit_type = (this.task as any).audit_type
    let checkUserId = puid[0].quality_uid
    //JiDu 兼容jiduNlpPage
    if((this.task as any).from === 'jiduNlpPage'){
      const url = `${JIDU_DOMAIN}/nlp?type=56&qid=${id}&inspectmid=${mid}&audit_type=${audit_type}&check_user=${checkUserId}&version=2` + (this.$route.query.pkg_id ? `&pkg_id=${this.$route.query.pkg_id}` : "")
      window.open(url)
    }else if ((this.task as any).from) {
      let url = `${DOMAIN}/tools/`
      // 移动asr项目 https无法访问 改为http访问


      if(mid && mobileProject.indexOf(mid * 1) > -1){
        url = `${HTTPDOMAIN}/tools/`
      }

      window.open(
        `${url}${(this.task as any).from}.html?type=56&qid=${id}&inspectmid=${mid}&audit_type=${audit_type}&check_user=${checkUserId}&version=2` + (this.$route.query.pkg_id ? `&pkg_id=${this.$route.query.pkg_id}` : "")
      );
    } else {
      window.open(
        `${DOMAIN}/tools/markPage.html?type=56&qid=${id}&inspectmid=${mid}&audit_type=${audit_type}&check_user=${checkUserId}&version=2` + (this.$route.query.pkg_id ? `&pkg_id=${this.$route.query.pkg_id}` : "")
      );
    }
  }
  //查看
  private handleShow(id, mid,puid) {
    this.$nextTick(() => {
      this.showId = id;
    });
    let audit_type = (this.task as any).audit_type
    let checkUserId = puid[0].quality_uid
    if((this.task as any).from === 'jiduNlpPage'){
      const url = `${JIDU_DOMAIN}/nlp?type=56&qid=${id}&inspectmid=${mid}`
      window.open(url)
    }else if ((this.task as any).from) {
      let url = `${DOMAIN}/tools/`
      // 移动asr项目 https无法访问 改为http访问


      if(mid && mobileProject.indexOf(mid * 1) > -1){
        url = `${HTTPDOMAIN}/tools/`
      }

      window.open(
        `${url}${(this.task as any).from}.html?type=56&qid=${id}&inspectmid=${mid}`
      );
    } else {
      window.open(
        `${DOMAIN}/tools/markPage.html?type=56&qid=${id}&inspectmid=${mid}`
      );
    }
  }
  private formatDuring(mss) {
    if (mss < 60) {
      return `0分${mss}秒`;
    }
    let s = parseInt((mss % 60).toString()); // 秒
    let m = parseInt((mss / 60).toString()); // 分
    if (m > 60) {
      var h = parseInt((m / 60).toString()); // 小时
      m = parseInt((m % 60).toString());
    }
    if (h) {
      if (m) {
        return `${h}时${m}分${s}秒`;
      } else {
        return `${h}时0分${s}秒`;
      }
    }
    if (m) {
      return `${m}分${s}秒`;
    } else {
      return `0分${s}秒`;
    }
    return;
  }
}
